const initialState = {
  isFetching: true,
  brands: [],
  models: [],
  engines: [],
  bodies: [],
  transmissions: [],
  requestSent: false,
  error: false,
};

export default function stock(state = initialState, action) {
  switch (action.type) {
    case "REQUEST_VEHICLE_PARAMETER":
      return state;
    case "VEHICLE_REQUESTED":
      return Object.assign({}, state, {
        isFetching: true,
        requestSent: false,
      });
    case "RECEIVE_VEHICLE_PARAMETER":
      const property =
        action.parameter === "body" ? "bodies" : action.parameter + "s";

      return Object.assign({}, state, {
        isFetching: false,
        [property]: action.data,
      });
    case "VEHICLE_REQUEST_CONFIRMED":
      return Object.assign({}, state, {
        isFetching: false,
        requestSent: true,
      });
    case "VEHICLE_REQUES_FAILED":
      return Object.assign({}, state, {
        isFetching: false,
        error: true,
      });
    default:
      return state;
  }
}
